import styled from 'styled-components';

import { Collapse } from 'components/ui';

export const SwitchContainer = styled.div<{ disabled?: boolean }>`
  ${({ disabled, theme }) => (disabled ? `color: ${theme.secondaryTextColor}` : '')};
  margin-bottom: 0.5rem;
  max-width: 160px;
  text-align: right;

  button {
    width: 44px;
  }

  span {
    color: ${({ theme }) => theme.secondaryTextColor};
    cursor: pointer;
    margin: 0 0.25rem 0 0;
  }
`;

export const AdvancedFiltersCollapse = styled(Collapse)`
  margin: 0 0 8px 8px;
  width: 324px;

  .ant-collapse-expand-icon {
    padding-inline-end: 0 !important;
  }

  .ant-collapse-content-box {
    background: ${({ theme }) => theme.secondaryBackgroundColor};
    padding: 0 8px 6px 36px !important;
  }
`;
